import { CSSProperties } from "react";
import { colorPrimary } from "@/constants/colors";
import { IRenderOptionProps } from "./RenderOption.props";

const styles: CSSProperties = {
	color: colorPrimary,
	fontFamily: "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
	fontSize: 13,
	fontStyle: "inherit",
	fontWeight: "inherit",
	lineHeight: "inherit",
	letterSpacing: "inherit",
	textAlign: "left",
};

const RenderOption = ({ ...props }: IRenderOptionProps): JSX.Element => {
	return <li {...props} style={{ ...styles, ...props.style }} />;
};

export default RenderOption;
